export const languageOptions = [
    { value: "English", label: "English" },
    { value: "Japanese", label: "Japanese" }
]

export const gradingCompanyOptions = [
    { value: "CGC", label: "CGC" },
    { value: "PSA", label: "PSA" }
]
